
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whatsapp-chatbot-templates/[...slug]",
      function () {
        return require("private-next-pages/whatsapp-chatbot-templates/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whatsapp-chatbot-templates/[...slug]"])
      });
    }
  